import classNames from 'classnames'

import { FONT_COLORS_FORMATS } from 'core-components/library/richTextEditor/interface/custom-types'
import { TFontColors } from 'core-components/library/richTextEditor/interface/TFontColors'

import styles from './ColorSettingsPopup.module.scss'

interface IProps {
  colors: TFontColors[]
  onClick: (color?: FONT_COLORS_FORMATS) => void
  isBackgroundColor?: boolean
}

export const ColorSettingsPopup = (props: IProps) => {
  return (
    <div>
      <div
        className={styles.removeColor}
        onClick={() => {
          props.onClick(
            props.isBackgroundColor ? FONT_COLORS_FORMATS.white : FONT_COLORS_FORMATS.black
          )
        }}
      >
        <i className="kbase kbase-editor-eraser"></i>
        <div> Remove color</div>
      </div>
      <hr className={styles.hr} />
      <div className={styles.colors}>
        {props.colors.map((item, index) => (
          <div
            key={index}
            className={classNames(styles.colorBtn, item.classColor)}
            onClick={() => props.onClick(item.color)}
          ></div>
        ))}
      </div>
    </div>
  )
}
